import { createTheme } from '@mantine/core';

export const theme = createTheme({
  scale: 1.6,
  defaultRadius: 'sm',
  colors: {
    dark: [
      '#C1C2C5', // dark[0] - lightest text on dark
      '#A6A7AB', // dark[1]
      '#909296', // dark[2]
      '#5C5F66', // dark[3]
      '#373A40', // dark[4]
      '#2C2E33', // dark[5]
      '#25262B', // dark[6]
      '#1A1B1E', // dark[7]
      '#141517', // dark[8]
      '#101113', // dark[9] - darkest bg
    ],
  },
});
